var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.546 12.03c-.15 0-.3-.074-.375-.15L5.42 8.129a.59.59 0 010-.826.588.588 0 01.825 0L9.62 10.68l3.375-3.378a.588.588 0 01.825 0 .59.59 0 010 .826l-3.75 3.753c-.3.075-.45.15-.525.15z",
    fill: "#C4C4C4"
  })));
}
export default SvgDropdownArrow;